// shared/src/rrule-esm.ts
import * as RRuleLib from "rrule";
const lib = RRuleLib.default || RRuleLib;
export const RRule = lib.RRule;
export const rrulestr = lib.rrulestr;
export const Weekday = lib.Weekday;
export const datetime = lib.datetime;
//# sourceMappingURL=index.js.map